/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';

export const DatahubAPI = {
  abbvSearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/home-search', JSON.stringify(scoreParams))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  entitySearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/entity', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  ownershipSearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/ownership', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  commoditySearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/commodity', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  cyberSearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/cyber', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  bulkSearch: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('excel-upload', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  biteScore: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post(
        'bitescore/bitescore',
        JSON.stringify({ scoreParams: scoreParams }),
      )
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  biteList: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('bitescore/bitelist', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => {
        console.error('API call failed', err);
        return { success: false, result: err };
      }),

  watchlist: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post(
        'bitescore/watchlist',
        JSON.stringify({ scoreParams: scoreParams }),
      )
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  trade: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('bitescore/hscodes', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  cyber: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('bitescore/cyber', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  dataUpdates: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/updates', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  alias: async () =>
    (await initAxios('/datahub'))
      ?.post('data/alias')
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  indices: async (scoreParams: any) =>
    (await initAxios('/datahub'))
      ?.post('data/indices', JSON.stringify({ scoreParams: scoreParams }))
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  writeToIndex: async (query: any) =>
    (await initAxios('/datahub'))
      ?.post('opensearch/write-index', query)
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data?.body,
      }))
      .catch((err) => ({ success: false, result: err })),

  retrieveHTSCode: async (query: any) =>
    (await initAxios('/datahub'))
      ?.post('tariffs/hs-code', query)
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),

  retrieveForeignHTSCode: async (query: {
    code: string;
    sourceCountry: 'Mexico' | 'Canada';
    effectiveDate?: string;
    originCountryIso2?: string;
    originCountryName?: string;
    // Canada scope answers. These change which surtax records MATCH, so they
    // are sent to the server rather than applied to the response — a change
    // to any of them needs a fresh lookup.
    meltedAndPouredInChina?: boolean;
    smeltedAndCastInChina?: boolean;
    quotaSide?: 'within' | 'over';
  }) =>
    (await initAxios('/datahub'))
      ?.post('tariffs/foreign-hs-code', query)
      .then((resp) => ({
        success: resp.status === 200,
        result: resp.data,
      }))
      .catch((err) => ({ success: false, result: err })),
};

export default DatahubAPI;
